import { render, staticRenderFns } from "./form_terceira_etapa.vue?vue&type=template&id=37f8dfae"
import script from "./form_terceira_etapa.vue?vue&type=script&lang=js"
export * from "./form_terceira_etapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports